import { notification } from 'antd';
import './custom-notification.css';

const BASE_CLASS = 'crce-notification';

const baseStyle = {
  fontFamily:
    "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

const baseConfig = {
  duration: 4.5,
  placement: 'topRight' as const,
  zIndex: 9999,
  style: baseStyle,
};

export const Notification = {
  success: (message: string, description?: string, config?: any) => {
    return notification.success({
      ...baseConfig,
      message,
      description,
      ...config,
      className: `${BASE_CLASS} ${BASE_CLASS}--success ${config?.className ?? ''}`.trim(),
    });
  },

  error: (message: string, description?: string, config?: any) => {
    return notification.error({
      ...baseConfig,
      message,
      description,
      ...config,
      className: `${BASE_CLASS} ${BASE_CLASS}--error ${config?.className ?? ''}`.trim(),
    });
  },

  warning: (message: string, description?: string, config?: any) => {
    return notification.warning({
      ...baseConfig,
      message,
      description,
      ...config,
      className: `${BASE_CLASS} ${BASE_CLASS}--warning ${config?.className ?? ''}`.trim(),
    });
  },

  info: (message: string, description?: string, config?: any) => {
    return notification.info({
      ...baseConfig,
      message,
      description,
      ...config,
      className: `${BASE_CLASS} ${BASE_CLASS}--info ${config?.className ?? ''}`.trim(),
    });
  },

  open: (config: any) => {
    return notification.open({
      ...baseConfig,
      ...config,
      className: `${BASE_CLASS} ${config?.className ?? ''}`.trim(),
    });
  },
  destroy: () => {
    notification.destroy();
  },
};

export const initCustomNotification = () => {
  notification.config({
    placement: 'topRight',
    duration: 4.5,
    maxCount: 3,
    rtl: false,
    top: 24,
    bottom: 24,
  });
};

export default Notification;
